import { render } from "./StuffingComponent.vue?vue&type=template&id=668a2367"
import script from "./StuffingComponent.vue?vue&type=script&lang=js"
export * from "./StuffingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__